// Function that returns error or data from a promise
// This makes it easier to handle errors when using await
export default function resolve(promise) {
  return promise
    .then(data => {
      return [null, data];
    })
    .catch(err => [err]);
}
